/** @jsx jsx */
import { jsx } from '@emotion/core';

export function Appliances(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M55.9 22.27H45.36l-.56-4.88a4.18 4.18 0 00-4.16-3.71H29.4a4.18 4.18 0 00-4.16 3.71l-4.47 38.93h28.5L46.36 31z'
      />
      <path
        className='prefix__cls-2'
        d='M45.36 22.27h-22a3.6 3.6 0 00-3.4 2.45L14.1 42.11M21.27 51.96h27.55M35 40.9v6.31'
      />
    </svg>
  );
}

export function AsphaltConcrete(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M18.24 18.24h33.52v33.52H18.24zM25.8 18.24v33.52M35 18.24v3'
      />
      <path
        strokeDasharray='5.5 5.5'
        fill='none'
        stroke='#fff'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M35 26.74v19.27'
      />
      <path className='prefix__cls-2' d='M35 48.76v3M43.77 18.24v33.52' />
    </svg>
  );
}
export function BarberStation(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {
            '.prefix__cls-2,.prefix__cls-3{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}.prefix__cls-3{strokeLinecap:round}'
          }
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path className='prefix__cls-2' d='M17.12 17.21H52.7v35.58H17.12z' />
      <path
        className='prefix__cls-2'
        d='M36.22 37.58h9.6v15.21h-9.6zM21.35 37.58H31.8v10.45H21.35zM26.57 37.58v10.44'
      />
      <path className='prefix__cls-3' d='M28.2 24.34l4.19 3.55 15.81 3.44' />
      <path className='prefix__cls-3' d='M28.2 31.33l4.19-3.55 15.81-3.44' />
      <ellipse className='prefix__cls-2' cx={25.22} cy={31.45} rx={2.98} ry={2.25} />
      <ellipse className='prefix__cls-2' cx={25.22} cy={23.94} rx={2.98} ry={2.25} />
    </svg>
  );
}

export function Billboards(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M15.49 20.34h39.02v24.02H15.49zM35 44.36v13.17M31.23 57.53h7.98M35 20.34v-3.36'
      />
    </svg>
  );
}

export function Bridge(props) {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 70 70'
      width='70'
      height='70'
      xmlSpace='preserve'
      {...props}
    >
      <style>
        {
          '.prefix__st1{fill:none;stroke:#fff;strokeWidth:2;strokeLinecap:round;strokeLinejoin:round}'
        }
      </style>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__st1'
        d='M55.6 44c-12.8-7-28.4-7-41.2 0V30.5c12.8-7 28.4-7 41.2 0V44zM9.6 47.1C24.7 36 45.3 36 60.4 47.1M35 22.5v16.3M55.6 28.3V44M14.4 28.3V44M14.4 37.3c12.8-7 28.4-7 41.2 0'
      />
    </svg>
  );
}

export function Carpet(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M13.68 22.58h42.64v24.84H13.68zM13.68 28.79H9.26M13.68 22.58H9.26M13.68 47.42H9.26M13.68 35H9.26M13.68 41.21H9.26M60.74 28.79h-4.42M60.74 22.58h-4.42M60.74 47.42h-4.42M60.74 35h-4.42M60.74 41.21h-4.42M19.93 22.58v24.84M50.36 22.58v24.84'
      />
      <path
        className='prefix__cls-2'
        transform='rotate(-45 35.003 34.481)'
        d='M29.98 29.46h10.04V39.5H29.98z'
      />
    </svg>
  );
}

export function CCTV(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path className='prefix__cls-2' d='M41.79 38.84l-15.9-11.02 6.94-10 18.39 12.74-9.43 8.28z' />
      <path
        className='prefix__cls-2'
        d='M43.17 37.62l6.85 4.74 4.59-6.62-5.19-3.6-6.25 5.48zM17.57 35.67h5.58v16.52h-5.58zM35.86 34.25s-2.4 11.11-12.7 9.68'
      />
    </svg>
  );
}

export function Furniture(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M19 31.59a16.09 16.09 0 0032.05 0zM35.05 31.35V24a3 3 0 013-3 3 3 0 013 3v1.69M26.89 31.59v-3.66M35.05 46.2v9.43'
      />
    </svg>
  );
}

export function LandscapingStone(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M16.07 49.06l6.32-27.66 11.3 11.52 13.82-3.06.94 19.2H16.07z'
      />
      <path
        className='prefix__cls-2'
        d='M33.69 32.92l-7.02 16.14 20.84-19.2-25.12-8.46 34.69-.23'
      />
      <path className='prefix__cls-2' d='M47.51 29.86l9.57-8.69-8.63 27.89' />
    </svg>
  );
}

export function Landscaping(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <ellipse className='prefix__cls-2' cx={19.86} cy={31.92} rx={6.47} ry={11.69} />
      <circle className='prefix__cls-2' cx={36.45} cy={40.92} r={4.99} />
      <path
        className='prefix__cls-2'
        d='M19.86 49.62v-7.07M36.45 45.9v3.72M31.47 30.19l13.71-9.96 13.7 10.52'
      />
      <path className='prefix__cls-2' d='M55.03 27.79v21.83H12.18' />
      <path
        className='prefix__cls-2'
        d='M59.43 37.38H46.36v11.61M50.81 37.38v11.61M45.17 27.79v2.96'
      />
    </svg>
  );
}

export function MechanicalSecurityDoor(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M23.78 14.05h22.88v40.88H23.78zM26.78 37.65v3.94M35.22 31.03v3.03'
      />
      <circle className='prefix__cls-2' cx={35.22} cy={32.47} r={5.17} />
      <path
        className='prefix__cls-2'
        d='M32.05 27.84v-3.53a3.17 3.17 0 013.17-3.17 3.17 3.17 0 013.17 3.17v3.53M18.68 54.93h33.68'
      />
    </svg>
  );
}

export function OutdoorPipes(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M49.31 18.02v-3.64H36.5v3.64h2.49v15.16H36.5v3.64h2.49v15.16H36.5v3.65h12.81v-3.65H46.9V36.82h2.41v-3.64H46.9V18.02h2.41zM22.03 55.63h7.9v-9.17h2.42v-3.67h-2.42V27.66h2.42V23.98h-2.42v-9.6h-7.9v9.6h-2.49V27.66h2.49v15.13h-2.49v3.67h2.49v9.17z'
      />
    </svg>
  );
}

export function PartitionWall(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path className='prefix__cls-2' d='M24.89 45.78l-10.26 4.4V27.02l10.26-4.4v23.16z' />
      <path
        className='prefix__cls-2'
        d='M24.74 45.78L35 50.18V27.02l-10.26-4.4v23.16zM45.26 45.78L35 50.18V27.02l10.26-4.4v23.16z'
      />
      <path className='prefix__cls-2' d='M45.11 45.78l10.26 4.4V27.02l-10.26-4.4v23.16z' />
    </svg>
  );
}

export function Electric(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M31.8 36.69l-3.14 13.55h4.19l-2.24 9.2a.64.64 0 001.16.5l9.46-14.82h-4.54L40 36.69zM15.63 50.92a19.32 19.32 0 0138.63 0'
      />
      <circle className='prefix__cls-2' cx={34.94} cy={19.44} r={7.9} />
    </svg>
  );
}

export function Plumbing(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path className='prefix__cls-2' d='M15.63 50a19.32 19.32 0 1138.63 0' />
      <circle className='prefix__cls-2' cx={34.94} cy={18.55} r={7.9} />
      <path
        className='prefix__cls-2'
        d='M41.23 49.6a6.23 6.23 0 01-12.46 0c0-3.45 6.23-11.72 6.23-11.72s6.23 8.27 6.23 11.72z'
      />
    </svg>
  );
}

export function SwimmingPool(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M36.22 24.21V23a3.92 3.92 0 00-3.93-3.92A3.92 3.92 0 0028.36 23v17.29M49.69 24.21V23a3.92 3.92 0 00-3.93-3.92A3.92 3.92 0 0041.83 23v17.29M41.83 29.67H28.36M41.83 36.14H28.36M17 43.74c3.74 0 3.74 2.27 7.49 2.27s3.75-2.27 7.49-2.27S35.77 46 39.52 46s3.75-2.27 7.5-2.27S50.77 46 54.52 46M17 49.47c3.74 0 3.74 2.27 7.49 2.27s3.75-2.27 7.49-2.27 3.75 2.27 7.5 2.27 3.75-2.27 7.5-2.27 3.75 2.27 7.5 2.27'
      />
    </svg>
  );
}

export function TrailerLocks(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <circle className='prefix__cls-2' cx={34.72} cy={31.57} r={6.04} />
      <path
        className='prefix__cls-2'
        d='M23.87 31.57A10.85 10.85 0 1143.46 38h15.88M34.72 37.6v4.82M47.44 43.2l-2.78 3.52H30.35l-4.83 4.83h-7.24V43.2h29.16z'
      />
    </svg>
  );
}

export function TruckDock(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path className='prefix__cls-2' d='M19.83 22.38h30.35v30.35H19.83z' />
      <path
        className='prefix__cls-2'
        d='M13.58 17.27h42.84v35.45H13.58zM19.83 28.65h29.46M19.83 33.93h29.46M19.83 40.06h29.46M19.83 46.19h29.46'
      />
    </svg>
  );
}

export function WallPanels(props) {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 70 70'
      width='70'
      height='70'
      xmlSpace='preserve'
      {...props}
    >
      <style>{'.prefix__st2{fill:none;stroke:#fff;strokeWidth:1.7615;strokeLinejoin:round}'}</style>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        fill='none'
        stroke='#fff'
        strokeWidth={2}
        strokeLinejoin='round'
        d='M18.2 18.2h33.6v33.6h-6.7V38.4h-6.7v13.4H18.2z'
      />
      <path
        className='prefix__st2'
        d='M24.9 24.9h6.7v6.7h-6.7zM38.4 24.9h6.7v6.7h-6.7zM24.9 38.4h6.7v6.7h-6.7z'
      />
    </svg>
  );
}

export function WindTurbine(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <ellipse className='prefix__cls-2' cx={35} cy={19.62} rx={4.13} ry={10.49} />
      <ellipse
        className='prefix__cls-2'
        cx={22.47}
        cy={44.53}
        rx={10.49}
        ry={4.13}
        transform='rotate(-40.73 22.476 44.527)'
      />
      <ellipse
        className='prefix__cls-2'
        cx={47.53}
        cy={44.53}
        rx={4.13}
        ry={10.49}
        transform='rotate(-49.27 47.531 44.52)'
      />
      <circle className='prefix__cls-2' cx={34.91} cy={35.31} r={2.06} />
    </svg>
  );
}

export function WoodFlooring(props) {
  return (
    <svg
      id='prefix__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 70 70'
      width='70'
      height='70'
      {...props}
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:none;stroke:#fff;strokeLinejoin:round;strokeWidth:2px}'}
        </style>
      </defs>
      <circle cx={35} cy={35} r={35} fill='#55dcac' />
      <path
        className='prefix__cls-2'
        d='M14.99 14.78h40.45v40.45H14.99zM28.47 14.78v40.44M41.95 14.78v40.44M14.99 35.05h13.48M42.45 35.05h13.48M27.93 26.15h13.48M27.93 44.15h13.48'
      />
    </svg>
  );
}

export function Handrails() {
  return (
    <svg
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <rect width='64' height='64' rx='32' fill='url(#pattern0)' />
      <defs>
        <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use xlinkHref='#image0' transform='scale(0.0070922)' />
        </pattern>
        <image
          id='image0'
          width='141'
          height='141'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  );
}

export function HospitalBed(props) {
  return (
    <svg
      width={64}
      height={64}
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <rect width={64} height={64} rx={32} fill='url(#prefix__pattern0)' />
      <defs>
        <pattern id='prefix__pattern0' patternContentUnits='objectBoundingBox' width={1} height={1}>
          <use xlinkHref='#prefix__image0' transform='scale(.0071)' />
        </pattern>
        <image
          id='prefix__image0'
          width={141}
          height={141}
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  );
}
export function Wiring() {
  return (
    <svg
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <rect width='64' height='64' rx='32' fill='url(#pattern0)' />
      <defs>
        <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use xlinkHref='#image0' transform='scale(0.0070922)' />
        </pattern>
        <image
          id='image0'
          width='141'
          height='141'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  );
}

export function Wardrobe() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m21.6 14.31h27.16v41.38h-27.16z' />
        <path d='m35.18 14.31v41.38' />
        <path d='m38.46 37.59v3.39' />
        <path d='m31.67 37.59v3.39' />
      </g>
    </svg>
  );
}

export function HospitalFurniture() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m21.47 33.73h33.26v4.31h-33.26z' />
        <path d='m24.53 48.48v-10.43' />
        <path d='m51.69 38.05v10.43' />
        <path d='m26.4 33.92v-4.37h22.84v4.37' />
        <path d='m21.92 33.84-10.8-8.58' />
      </g>
    </svg>
  );
}

export function Cabinetry() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m15.31 22.45h19.69v26.45h-19.69z' />
        <path d='m35 22.45h19.69v26.45h-19.69z' />
        <path d='m15.31 30.26h39.38' />
        <path d='m31 37.09v3.9' />
        <path d='m39 37.09v3.9' />
      </g>
    </svg>
  );
}

export function HouseGraphIcon() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.5215 1.14669C16.1664 0.929371 15.7073 0.953518 15.3753 1.21913L0.375281 13.2191L0.282197 13.3036C-0.0642831 13.6598 -0.0993634 14.2266 0.219107 14.6247L0.303551 14.7178C0.659759 15.0643 1.22658 15.0993 1.62467 14.7809L16 3.28L30.3753 14.7809L30.4781 14.8531C30.9017 15.113 31.4624 15.0228 31.7808 14.6247C32.1259 14.1934 32.0559 13.5641 31.6247 13.2191L16.6247 1.21913L16.5215 1.14669ZM27.9932 15.8834C27.9355 15.386 27.5128 15 27 15L26.8834 15.0067C26.386 15.0645 26 15.4872 26 16V29H5.99998V16L5.99325 15.8834C5.93548 15.386 5.51281 15 4.99998 15C4.44769 15 3.99998 15.4477 3.99998 16V30L4.0067 30.1166C4.06447 30.614 4.48714 31 4.99998 31H27L27.1166 30.9933C27.6139 30.9355 28 30.5128 28 30V16L27.9932 15.8834ZM21.7071 18.7071L24 21V15H18L20.2928 17.2928L17 20.585L14.7071 18.2929L14.6129 18.2097C14.2206 17.9047 13.6534 17.9324 13.2929 18.2929L8.29287 23.2929L8.20968 23.3871C7.90466 23.7794 7.93239 24.3466 8.29287 24.7071L8.38708 24.7903C8.77937 25.0953 9.3466 25.0676 9.70708 24.7071L14 20.415L16.2929 22.7071L16.3871 22.7903C16.7794 23.0953 17.3466 23.0676 17.7071 22.7071L21.7071 18.7071Z'
        fill='#0827C7'
      />
    </svg>
  );
}

export function Lockers() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m17.92 18.33h8.54v33.33h-8.54z' />
        <path d='m20.79 35v2.89' />
        <path d='m23.85 35v2.89' />
        <path d='m26.46 18.33h8.54v33.33h-8.54z' />
        <path d='m29.33 35v2.89' />
        <path d='m32.39 35v2.89' />
        <path d='m35 18.33h8.54v33.33h-8.54z' />
        <path d='m37.87 35v2.89' />
        <path d='m40.93 35v2.89' />
        <path d='m43.54 18.33h8.54v33.33h-8.54z' />
        <path d='m46.41 35v2.89' />
        <path d='m49.47 35v2.89' />
      </g>
    </svg>
  );
}

export function PalletRacks() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m17.9 19.7v30.6' />
        <path d='m52.1 19.7v30.6' />
        <path d='m17.9 26h34.2' />
        <path d='m17.9 35.82h34.2' />
        <path d='m17.9 45.63h34.2' />
        <path d='m35 19.7v30.6' />
      </g>
    </svg>
  );
}

export function EmergencyGenerator() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m11.84 19.48h46.31v29.56h-46.31z' />
        <circle cx='49.66' cy='27.96' r='3.95' />
        <circle cx='49.66' cy='40.76' r='3.95' />
        <path d='m27.46 30.6h13.38v8.48h-13.38z' />
        <path d='m16.08 30.6v8.48' />
        <path d='m19.22 30.6v8.48' />
        <path d='m22.35 30.6v8.48' />
        <path d='m13.43 49.04h7.93v3.58h-7.93z' />
        <path d='m48.43 49.04h7.93v3.58h-7.93z' />
      </g>
    </svg>
  );
}

export function SpecialHVAC() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m22.01 18.25h25.98v34.76h-25.98z' />
        <path d='m26.39 24.82h8.61' />
        <path d='m26.39 28.67h8.61' />
        <path d='m26.39 32.52h8.61' />
        <path d='m26.39 36.37h8.61' />
        <path d='m47.99 24.82h-6.61v8.55h6.61' />
        <path d='m28.93 53 2.91-9.38h16.15' />
      </g>
    </svg>
  );
}

export function LightPoleFixture() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m35 54.5v-32.22a5.43 5.43 0 0 0 -5.44-5.43 5.44 5.44 0 0 0 -5.44 5.43v.64' />
        <path d='m35 54.5v-32.22a5.43 5.43 0 0 1 5.44-5.43 5.44 5.44 0 0 1 5.44 5.43v.64' />
        <circle cx='24.06' cy='26.75' r='3.58' />
        <circle cx='45.88' cy='26.75' r='3.58' />
      </g>
    </svg>
  );
}

export function StormWater() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m18.33 36.81h33.33v9.73h-33.33z' />
        <path d='m13.13 34.2h5.2v14.78h-5.2z' />
        <path d='m32.4 15.95h5.2v14.78h-5.2z' transform='matrix(0 -1 1 0 11.66 58.34)' />
        <path d='m51.67 34.2h5.2v14.78h-5.2z' />
        <path d='m29.51 25.94h10.87v10.87h-10.87z' />
      </g>
    </svg>
  );
}

export function SeatingBooth() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m11.78 39.28h15.01v8.42h-15.01z' />
        <path d='m11.78 39.28-3.34-11.7' />
        <path d='m43.16 39.28h15.06v8.42h-15.06z' transform='matrix(-1 0 0 -1 101.37 86.99)' />
        <path d='m58.22 39.28 3.34-11.7' />
        <path d='m21.27 31.92h27.46' />
        <path d='m35 48.32v-16.4' />
      </g>
    </svg>
  );
}

export function WalkinFridge() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m22.19 13.19h25.8v42.07h-25.8z' />
        <path d='m22.19 26.43h25.8' />
        <path d='m26.33 37.59v4.73' />
        <path d='m26.33 17.63v4.73' />
        <path d='m32.63 36.88h6.15v6.15h-6.15z' />
      </g>
    </svg>
  );
}

export function GreaseInterceptor() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m15.62 23.29h38.76v23.9h-38.76z' />
        <path d='m35 47.19v-19.73' />
        <path d='m15.62 38.8c1.93 0 1.93 2 3.87 2s1.94-2 3.87-2 1.94 2 3.88 2 1.94-2 3.88-2 1.94 2 3.88 2' />
        <path d='m35 31c1.94 0 1.94 2 3.87 2s1.94-2 3.88-2 1.93 2 3.87 2 1.94-2 3.88-2 1.94 2 3.88 2' />
      </g>
    </svg>
  );
}

export function RetainingWall() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m30.09 43.91h22.74v6.51h-22.74z' />
        <path d='m39.84 43.91h-9.75v-25.58h4.87z' />
        <path d='m17.17 35.37h12.92v15.05h-12.92z' />
      </g>
    </svg>
  );
}

export function Buses() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m25.41 16.29h19.54a4.52 4.52 0 0 1 4.52 4.52v26.68a0 0 0 0 1 0 0h-28.59a0 0 0 0 1 0 0v-26.68a4.52 4.52 0 0 1 4.53-4.52z' />
        <path d='m20.88 47.49h8.04v4.97h-8.04z' />
        <path d='m41.43 47.49h8.04v4.97h-8.04z' />
        <path d='m20.88 35.98h28.59v11.51h-28.59z' />
        <path d='m20.88 39.57h6.25v4.41h-6.25' />
        <path d='m49.47 43.98h-6.25v-4.41h6.25' />
        <path d='m20.88 20.81h28.59' />
      </g>
    </svg>
  );
}

export function WashingMachine() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m20.93 16.54h28.14v36.93h-28.14z' />
        <path d='m20.93 24.33h28.14' />
        <circle cx='35' cy='37.9' r='8.26' />
        <path d='m35 33a4.93 4.93 0 0 1 4.93 4.93' strokeLinecap='round' />
        <path d='m25.09 20.61h3.81' strokeLinecap='round' />
      </g>
    </svg>
  );
}
export function RoboticPalletMover() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m18.44 19.39h12.1v24.91h-12.1z' />
        <path d='m30.54 42.03h25.68' />
        <circle cx='20.73' cy='49.57' r='2.29' />
        <circle cx='50.75' cy='49.57' r='2.29' />
        <path d='m21.94 40.23h4.44' />
        <path d='m21.94 37.22h4.44' />
      </g>
    </svg>
  );
}
export function Fencing() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m54.59 39a8.05 8.05 0 0 0 -11.39 11.35z' />
        <path d='m54 49.76-5.11-5.1' />
        <path d='m43.2 38.96-19.31-19.31' />
        <path d='m15.41 39a8.05 8.05 0 0 1 11.39 11.35z' />
        <path d='m16 49.76 5.11-5.1' />
        <path d='m26.8 38.96 19.31-19.31' />
      </g>
    </svg>
  );
}
export function OutdoorLighting() {
  return (
    <svg viewBox='0 0 70 70' width='70' height='70' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='35' cy='35' fill='#55dcac' r='35' />
      <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='1'>
        <path d='m38.81 39.3h-21.03l4-6.79h13.03z' />
        <path d='m34.81 46.09h-14.03l-3-6.79h21.03z' />
        <path d='m28.29 32.51v-3.31a10.23 10.23 0 0 1 10.22-10.2 10.22 10.22 0 0 1 10.21 10.2v20.57' />
      </g>
    </svg>
  );
}

export function StripedBoxBig() {
  return (
    <svg
      width='94'
      height='103'
      viewBox='0 0 94 103'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_3955_17481)'>
        <circle cx='47' cy='32' r='32' fill='#55DCAC' />
      </g>
      <path
        d='M27 32H68'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M40 14L40 50'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M55 14L55 50'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <filter
          id='filter0_d_3955_17481'
          x='0'
          y='0'
          width='94'
          height='103'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='15'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_3955_17481'
          />
          <feOffset dy='24' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.486275 0 0 0 0 0.85098 0 0 0 0 0.686275 0 0 0 0.908599 0'
          />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3955_17481' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_3955_17481'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
}

export function StripedBox({ ...props }) {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='greenish'
      {...props}
    >
      <path
        d='M2 30L30 2'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 22L22 2'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 14L14 2'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 6L6 2'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 30L30 10'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 30L30 18'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26 30L30 26'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function AudioJack({ ...props }) {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='greenish'
      {...props}
    >
      <path
        d='M8 31H21.5C25.0899 31 28 28.0899 28 24.5C28 20.9101 25.0899 18 21.5 18H7.5C3.91015 18 1 15.0899 1 11.5C1 7.91015 3.91015 5 7.5 5H8'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25 5H29'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.0371 1.76318L28.9636 0.999948'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.0371 8L28.9636 8.76324'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 2C12.3431 2 11 3.34315 11 5C11 6.65685 12.3431 8 14 8H22V2H14Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function PlateIcon({ ...props }) {
  return (
    <svg
      width='36'
      height='37'
      viewBox='0 0 36 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='greenish'
      {...props}
    >
      <path
        d='M22.3867 16.9741V9.28003'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.5527 16.9741V9.28003'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.6858 9.28003C26.6858 9.28003 27.0226 14.4948 27.0226 16.3005C27.0226 18.1062 26.0426 19.7879 24.6719 20.3902L25.1082 34.0346C25.1082 34.9351 24.3714 35.6719 23.4709 35.6719C22.5704 35.6719 21.8336 34.9351 21.8336 34.0346L22.2686 20.3902C20.898 19.7879 19.918 18.1833 19.918 16.3005C19.918 14.4176 20.2548 9.28003 20.2548 9.28003'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.8303 24.4108H31.656L30.9122 34.0743C30.9122 34.9526 31.6314 35.6718 32.5097 35.6718C33.388 35.6718 34.1072 34.9526 34.1072 34.0743V9.61213C34.1072 9.41332 33.9306 9.25427 33.733 9.28351C32.3857 9.47764 31.6279 10.7512 31.2467 12.8902C30.4187 17.5424 30.131 21.8368 30.0421 23.5852C30.0187 24.0354 30.3777 24.4108 30.8292 24.4108H30.8303Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.1959 35.6718C9.62126 35.6718 1.85938 27.9099 1.85938 18.3353C1.85938 8.76072 9.62126 1 19.1959 1C24.3077 1 28.9038 3.21267 32.0766 6.73283'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.4137 7.72803C9.66199 9.77697 7.11719 13.7591 7.11719 18.3353C7.11719 24.9639 12.4571 30.3459 19.0705 30.4137'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.6607 6.76089C21.5638 6.43343 20.4013 6.25684 19.1979 6.25684C17.9945 6.25684 16.9244 6.4194 15.8672 6.72229'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function TreeIcon({ ...props }) {
  return (
    <svg
      width='38'
      height='33'
      viewBox='0 0 38 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='greenish'
      {...props}
    >
      <path d='M38 31.6086H0' stroke='white' strokeWidth='2' strokeLinejoin='round' />
      <path
        d='M23.0723 14.2174C23.0723 14.2174 23.1876 10.7391 27.1437 10.7391C31.5544 10.7391 31.2151 15.6087 31.2151 15.6087C31.2151 15.6087 35.9651 15.9148 35.9651 20.4783C35.9651 25.7374 32.3619 26.0435 31.2151 26.0435C31.2151 26.0435 33.2508 26.913 33.2508 28.8261C33.2508 30.4817 31.5137 31.6087 29.1794 31.6087'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M7.83099 15.6296C6.73849 14.7113 6.10742 13.3617 6.10742 11.4348C6.10742 9.29217 7.80385 7.26087 10.1789 7.26087C12.3435 7.26087 12.8931 7.95652 12.8931 7.95652C11.3664 3.21913 15.6481 1 16.9646 1C19.8892 1 21.7553 2.27304 21.7553 5.9113C21.7553 5.9113 24.3271 4.3113 26.3831 5.60522C27.686 6.43304 28.6292 8.34609 27.1431 10.7391'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M11.577 17.7234C11.577 17.7234 10.7695 15.6086 8.14342 15.6086C6.23663 15.6086 2.71484 17.3895 2.71484 21.1739C2.71484 24.9582 5.76842 25.3478 6.1077 25.3478C6.1077 25.3478 4.07199 26.1269 4.07199 28.1304C4.07199 30.1339 6.4877 31.6086 7.46484 31.6086'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M13.5723 12.1304L14.9294 17.6956L19.0008 20.4782V31.6086'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M19.6793 10.7391V14.913L17.6504 19.553'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M27.1426 17.6957L24.4283 27.4348L22.3926 31.6087'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M23.0723 19.7826L24.4294 27.4348L29.858 22.5652'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M8.14258 21.8695L12.214 28.1304L15.6069 31.6086'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M7.46484 28.1304H12.2148L12.8934 21.8695'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function SQFT({ ...props }) {
  return (
    <svg
      width='43'
      height='38'
      viewBox='0 0 43 38'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='greenish'
      {...props}
    >
      <path
        d='M1 19H42'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 1L14 37'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M29 1L29 37'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
